import { useEffect } from "react";

import { getQuerySelector } from "../utils/functions";

const RegisterSelector = ({ outAuditory }) => {
  const handleClickOutside = (event) => {
    const lastSelector = getQuerySelector(event.target);
    outAuditory.selector = lastSelector;
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default RegisterSelector;
